import { Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { Container } from '../../containers/container';
import { ApiKey, ApiKeyInput } from '../../shared/entities/apiKey/apiKey';
import { ApiKeysService } from '../../shared/services/apiKeys/apiKeys.service';
import { LoadingService } from '../../shared/services/loading.service';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-api-key',
  templateUrl: './api-key.component.html',
  styleUrls: ['./api-key.component.scss']
})
export class ApiKeyComponent
    extends Container<fromGraphQl.ApiKeyQueryResponse>
    implements OnInit, OnDestroy
  {
    public apiKey: ApiKey;
    public id: string;
    public routeSubscription: Subscription;
    public newKey: any;
    public newId: any;

    // form
    public apiKeyFormGroup: UntypedFormGroup;

    @ViewChild('APIDialog') APIDialog: TemplateRef<any>;
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private apiKeysService: ApiKeysService,
    loadingService: LoadingService,
    apollo: Apollo,
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
    @Inject('env') environment : any
  ) {
    super(apollo, loadingService, fromGraphQl.API_KEY_QUERY, environment);
  }

  ngOnInit(): void {
    const key = 'id';
    this.apiKeyFormGroup = this.fb.group({
      comment: [null]
    });
    // if we call this compobent with an ID, we want do load a Api KLey
    this.routeSubscription = this.route.params
      .pipe(
        filter((params) => params[key] !== undefined),
        take(1)
      )
      .subscribe((params) => {
        if (params[key] && params[key] !== 'create') {
          this.id = params[key];
        }
        this.subscribeToQuery({
          id: this.id,
        });
      });
  }
  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
    super.ngOnDestroy();
  }

  handleSubscriptionResult(data: fromGraphQl.ApiKeyQueryResponse): void {
    this.loadingService.setLoading(false);
    if (data) {
      this.queryRef.stopPolling();

      if (data.apiKey) {
        this.apiKeyFormGroup.patchValue(data.apiKey);
        this.apiKey = new ApiKey(data.apiKey);
      }
    }
  }


  saveApiKey(): void {
    this.loadingService.setLoading(true);
    const formModel = this.apiKeyFormGroup.value;
    const userModel = new ApiKeyInput();
    userModel.comment = formModel.comment;
    if (this.id) {
      userModel.id = this.id;
      this.apiKeysService.updateApiKey(
        userModel,
        this.returnCallback(this.router)
      );
    } else {
      // this.apiKeysService.createApiKey(userModel).subscribe((result: any)=> {
      //   this.newKey = result.apiKeyData;
      //   this.newId = result.apiKeyId;
      //   this.loadingService.setLoading(false);
      //   let dialogRef = this.dialog.open(this.APIDialog,{autoFocus: false});
      //   dialogRef.afterClosed().subscribe((dialogResult: any) => {
      //     this.router.navigate(['/settings/developer/']);
      //   });
      // });
    }
  }

  returnCallback(router: Router): void {
    setTimeout(() => {
      this.loadingService.setLoading(false);
      router.navigate(['/settings/developer/']);
    }, 500);
  }

  abort(): void {
    this.router.navigate(['/settings/developer/']);
  }

}
